import { createSlice } from '@reduxjs/toolkit';

// todo: need to remove once api is done
const reducerName = 'projectDetails';
const initialState = {
  isLoading: false,
  data: [],
  searchTerm: null,
  currentProject: {
    isLoading: false,
    data: {},
    error: null,
  },
  currentProjectProspects: {
    isLoading: false,
    data: {},
    error: null,
  },
  addAction: {
    isLoading: false,
    data: {},
    error: null,
  },
  createReview: {
    isLoading: false,
    data: {},
    error: null,
  },
  removeAction: {
    isLoading: false,
    data: {},
    error: null,
  },
  notInFlow: false,
  notInAnyFlow: false,
  statusFilter: { id: null },
  filters: {}, // Updated to be more dynamic
  page: {
    limit: 20,
  },
  sort: {
    element: 'created_at',
    order: 'DESC',
  },
  projectStats: {
    isLoading: false,
    data: {},
    error: null,
  },
  projectLimitedData: {
    isLoading: false,
    data: {},
    error: null,
  },
};

const { reducer, actions: projectDetailsActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    applyFilter: (state, { payload: { dynamicID, type, value } }) => {
      if (!state.filters[dynamicID]) {
        state.filters[dynamicID] = {}; // Ensure the dynamic ID exists
      }
      state.filters[dynamicID][type] = value;
      if (state.page && state.page[dynamicID]) {
        state.page[dynamicID].number = 0;
      }
    },

    applyStatusFilter: (state, { payload }) => {
      const newState = { ...state, statusFilter: payload };
      if (newState.page) {
        newState.page = { ...newState.page };
        Object.keys(newState.page).forEach((dynamicID) => {
          // `limit` is a number, not a per-project page entry — skip it so the
          // selected page size (20/50/100) isn't clobbered.
          if (dynamicID === 'limit') return;
          newState.page[dynamicID] = { ...newState.page[dynamicID], number: 0 };
        });
      }

      return newState;
    },

    applyNotInFlow: (state, { payload }) => {
      const newState = { ...state, notInFlow: payload, searchTerm: '' };
      if (newState.page) {
        newState.page = { ...newState.page };
        Object.keys(newState.page).forEach((dynamicID) => {
          if (dynamicID === 'limit') return;
          newState.page[dynamicID] = { ...newState.page[dynamicID], number: 0 };
        });
      }

      return newState;
    },

    applyNotInAnyFlow: (state, { payload }) => {
      const newState = { ...state, notInAnyFlow: payload, searchTerm: '' };
      if (newState.page) {
        newState.page = { ...newState.page };
        Object.keys(newState.page).forEach((dynamicID) => {
          if (dynamicID === 'limit') return;
          newState.page[dynamicID] = { ...newState.page[dynamicID], number: 0 };
        });
      }

      return newState;
    },

    applyPage: (
      state,
      { payload: { dynamicID, number, clearSearch = true } }
    ) => {
      if (!state.page[dynamicID]) {
        state.page[dynamicID] = {}; // Ensure the dynamic ID exists
      }
      state.page[dynamicID].number = number;
      if (clearSearch) {
        state.searchTerm = '';
      }
    },

    applyLimit: (state, { payload: { limit } }) => {
      state.page.limit = limit;
      Object.keys(state.page).forEach((key) => {
        if (key !== 'limit' && state.page[key]) {
          state.page[key].number = 0;
        }
      });
    },

    resetFilter: (state) => {
      state.filters = {}; // Reset all dynamic filters
      state.searchTerm = '';
    },

    applySort: (state, { payload: { element, order } }) => {
      state.sort.element = element;
      state.sort.order = order;
    },

    applySearchTerm: (state, { payload }) => {
      // Create a new state object to avoid mutation
      const newState = { ...state, searchTerm: payload?.searchTerm };

      if (newState.page) {
        newState.page = { ...newState.page };
        Object.keys(newState.page).forEach((dynamicID) => {
          // `limit` is a number, not a per-project page entry — skip it so the
          // selected page size (20/50/100) isn't clobbered into `{ number: 0 }`.
          if (dynamicID === 'limit') return;
          newState.page[dynamicID] = { ...newState.page[dynamicID], number: 0 };
        });
      }

      return newState;
    },

    clearFilter: (state, { payload }) => {
      const { dynamicID, type, isMulti = false } = payload;
      if (!state.filters[dynamicID] || !state.filters[dynamicID][type]) {
        return;
      }
      state.filters[dynamicID][type] = isMulti ? [] : null;
    },

    clearAllFilter: (state) => {
      state.page = { ...initialState.page };
      state.filters = {
        ...initialState.filters,
        user: [null],
        changed: false,
      };
      state.statusFilter = { ...initialState.statusFilter };
      state.searchTerm = '';
      state.notInFlow = false;
    },

    clearData: (state) => {
      state.currentProjectProspects.data = {};
      state.currentProjectProspects.isLoading = true;
      state.currentProject.data = {};
      state.currentProject.isLoading = true;
    },

    setLoadingState: (state, { payload }) => {
      const { key, isLoading } = payload || {};
      if (state[key]) {
        state[key].isLoading = isLoading;
        state[key].error = null;
      }
    },

    fetchSuccess: (state, { payload }) => {
      const { key, data, status } = payload || {};
      if (state[key]) {
        state[key].isLoading = false;
        state[key].data = data;
        state[key].error = null;
        state[key].status = status;
      }
    },

    fetchFailure: (state, { payload }) => {
      const { key, error } = payload || {};
      if (state[key]) {
        state[key].isLoading = false;
        state[key].error = error;
      }
    },
  },
});

export { projectDetailsActions };
export default reducer;
